module.exports = __webpack_public_path__ + "static/media/laodong.bd0ff5a5.png";